import React, { useState, useEffect } from "react";
import EditIcon from "../Asserts/images/edit_icon.svg";
import ViewBtnArrow from "../Asserts/images/view-btn-arrow.svg";
import {
  updateLoadingStatus,
  fetchRoundPageCategory,
  updateMatchWeeks,
  updateRedeemPopup,
  updatePotTokenValue,
  updateSelectedPot,
  updateFixtureSelectedComponent,
  updatePickRemains,
  updateLeagueId,
} from "../Pages/RoundToJoin/roundToJoin.slice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { postData } from "../services/api";
import { baseURL } from "../services/axiosConfig";
import useToastMessage from "../Utiles/Toaster";
import toast, { Toaster } from "react-hot-toast";
import TokenRedeemPopUp from "../popups/tokenRedeemPopUp";
import editIcon from "../Asserts/images/editIcon.svg";
import { useNavigate } from "react-router";
import { updateVoteDetail, updateVoteNowPopup } from "../popups/votenow.slice";
import VotePopup from "../popups/votePopup";
import { createTokenModalOpen } from "../Pages/RoundToJoin/tocken.slice";
import { fetchFixtures } from "../Pages/PickDetail/pickDetail.slice";

function amountFormat(amount) {
  return amount?.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}



const RoundToJoinSection = ({
  league,
  viewFixtureHandler,
  round,
  timeLeft,
  leagueId,
  potInfo,
  btn_color,
  btn_text_color,
  cartType,
  gameName,
  gameId,
  
}) => {
  const navigate = useNavigate();
  const { showToast, showErrorToast } = useToastMessage();
  const dispatch = useDispatch();

  const matchWeeks =
    useSelector((state) => state.roundToJoin.roundToJoinPotData)
      ?.find((ele) => ele.league_id == leagueId)
      ?.pots.find((item) => item.id === round)
      ?.pot_matchweek?.split("-")[1] || "1";

  const pot = useSelector((state) => state.roundToJoin.roundToJoinPotData)
    ?.find((ele) => ele.league_id == leagueId)
    ?.pots.find((item) => item.id === round);

  const tokenRemaining = useSelector((state) => state.token.tokenRemaining)

  return (
    <div className="flex flex-col">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      {!timeLeft ? (
        <button
          style={{ color: btn_text_color, backgroundColor: btn_color }}
          className={`w-full cursor-pointer mt-4
    font-bold text-base sm:text-lg py-2 sm:py-3 
    rounded-lg shadow-lg transition text-center`}
          onClick={() => {
            const isAuthUser = localStorage.getItem("isAuthUser") === "true";
              if (!isAuthUser) {
                navigate("/signup");
                return;
              }

            // ✅ User logged in → Normal flow
            if (potInfo.max_pot_value > potInfo.current_pot_value) {
              const userInfo = localStorage.getItem("userInfo");
              const userId = userInfo ? JSON.parse(userInfo).userId : null;

              window.dataLayer.push({
                userId,
                event: "click",
                clickText: "Play Now",
                clickID: "btn-play-now",
                clickURL: "",
                roundId: potInfo?.id,
                leagueId: potInfo?.season_name,
                sportId: gameName,
              });

              dispatch(updateRedeemPopup(true));
              dispatch(updatePickRemains(potInfo.max_number_of_picks || 2));
              dispatch(updatePotTokenValue(potInfo.pot_token));
              dispatch(updateSelectedPot(potInfo.id));
              dispatch(updateLeagueId(leagueId));
            } else {
              showErrorToast("Entry closed for this round, please join other rounds.");
            }
          }}
        >
          Play Now
        </button>

      ) : (
        <button
          className="w-full opacity-50 cursor-pointer mt-4  border border-[#FFFFFF33] bg-[#FFFFFF1F] text-white font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition text-center"
          onClick={() => { }}
        >
          Entry Closed
        </button>
      )}
      {!timeLeft ? (
        <button
          className="
    w-full   
    flex justify-between px-2 items-center
    mt-4
    border-2 border-white/20
    bg-transparent
    text-white
    text-base sm:text-lg
    py-2 sm:py-3
    rounded-lg
    shadow-lg
    transition-all duration-200 ease-in-out
    focus:outline-none focus:ring-2 focus:ring-white/50
    cursor-pointer"
          onClick={() => {
            console.log(pot);
            dispatch(updateMatchWeeks(potInfo?.current_match_week));
            dispatch(updateSelectedPot(potInfo?.id));
            dispatch(updateLeagueId(potInfo?.league_id));
            // dispatch(updateRedeemPopup("fixture"));
            dispatch(updateRedeemPopup(false));
            dispatch(updatePotTokenValue(potInfo.pot_token));
            viewFixtureHandler(round, potInfo, null, null, "roundToJoin");
            dispatch(
              updateFixtureSelectedComponent({
                component: "",
                pickId: pot?.id || potInfo?.id,
                matchWeekId: potInfo?.current_match_week_id,
                // potId: potInfo.id,
              })
            );
          }}
        >
          View Fixtures <img src={ViewBtnArrow} className="h-6 w-6" />
        </button>
      ) : (
        <button
          className="
    w-full
    flex justify-center px-2 items-center
    mt-4
    bg-transparent
    text-white
    text-base sm:text-lg
    py-2 sm:py-3
    rounded-lg
    shadow-lg
    transition-all 
    border-none
    cursor-pointer
  "
          onClick={() => {
            let path = window.location.pathname;
            console.log(cartType)
            const state =
              path === "/rounds"
                ? {
                  page: path,
                  sub: cartType,
                  potId: potInfo.id,
                  matchWeeksId: potInfo.current_match_week_id,
                  btnName: "viewDetails",
                  seasonId: potInfo.season,
                  logo: potInfo.season_logo,
                  soasonName: potInfo.season_name,
                  potValue: potInfo.pot_value,
                  currency: potInfo.pot_currency,
                  status: potInfo.status,
                  round,
                  currentMatchWeek: potInfo.current_match_week || potInfo.pot_matchweek.split("-")[1],
                  matchWeeks: potInfo.pot_current_matchweek,
                  totalPick:
                    potInfo.active_picks_count + potInfo.lost_picks_count,
                  isTimeEnd: timeLeft,
                }
                : {
                  page: path,
                  sub: cartType,
                  potId: potInfo.id,
                  matchWeeksId: potInfo.current_match_week_id,
                  btnName: "viewDetails",
                  seasonId: potInfo.season,
                  logo: potInfo.season_logo,
                  soasonName: potInfo.season_name,
                  potValue: potInfo.pot_value,
                  currency: potInfo.pot_currency,
                  status: potInfo.status,
                  round,
                  currentMatchWeek: potInfo.current_match_week || potInfo.pot_matchweek.split("-")[1],
                  matchWeeks: potInfo.pot_current_matchweek,
                  totalPick:
                    potInfo.active_picks_count + potInfo.lost_picks_count,
                  isTimeEnd: timeLeft,
                };
            dispatch(fetchRoundPageCategory("compleated"));
            navigate("/V2-pickDetail", { state });
          }}
        >
          View Details
        </button>
      )}
    </div>
  );
};

const RenderPickRow = ({
  pickDetail,
  pickId,
  potInfo,
  label,
  teamType,
  cartType,
  viewFixtureHandler,
  round,
  timeLeft,
  leagueId,
  btn_color,
  lastEntryTimeLeft,
  btn_text_color,
  showErrorToast
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const potData = useSelector((state) => state.roundToJoin.roundToJoinPotData);

  const voteNowPot = useSelector((state) => state.voteNow.voteNowPot);

  const isVoteNowPopup = useSelector((state) => state.voteNow.isVoteNowPopup);

  const pot = potData
    ?.find((ele) => ele.league_id == leagueId)
    ?.pots.find((item) => item.id === round);

  const handlePickClick = (type) => {
    dispatch(updateMatchWeeks(potInfo?.current_match_week));
    dispatch(updateSelectedPot(pot?.id));
    dispatch(updateRedeemPopup(false));
    dispatch(updatePotTokenValue(pot?.pot_token));
    viewFixtureHandler(round, potInfo, potInfo.current_match_week_id, pickId, "mypot");
    dispatch(
      updateFixtureSelectedComponent({
        component: "choose pick",
        pickId,
        matchWeekId: potInfo.current_match_week_id,
        potId: potInfo.id,
        type: type,
        label: label
      })
    );
  };

  function voteNowHandler(pickId, potId) {

    try {
      dispatch(updateVoteNowPopup({ isOpenPopup: true, potId, pickId }));
    } catch (e) {
      console.log(e);
    }
  }
  const tokenRemaining = useSelector((state) => state.token.tokenRemaining)
  const hasPredictionLogo = pickDetail?.[0]?.prediction?.logo;

  let isTeamSelected =
    pickDetail?.[0]?.prediction?.team &&
    pickDetail?.[0]?.prediction?.team !== "NPY";

  const isLost = pickDetail?.[0]?.status === "Lost";
  const isWon = pickDetail?.[0]?.status === "Won" || pickDetail?.[0]?.status === "Win";
  const isJackPot = pickDetail?.[0]?.status === "JackPot";
  const baseButtonClass =
    "flex-1 min-h-[48px] text-[14px] flex justify-center items-center font-bold px-2 py-2 border-2 border-white/20 rounded-lg shadow-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-white/50";

  return (
    <div className="flex gap-4 w-full items-center">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      {isVoteNowPopup && (
        <VotePopup
          message="Would you like to split the pot?"
          potId={voteNowPot.pot}
          pickId={voteNowPot.pick}
          logo={potInfo.logo}
          jackpotId={potInfo.jackpot_id}
        />
      )}
      {isJackPot ? (
        <>
          <button
            className={`${baseButtonClass} ${!timeLeft
              ? `cursor-pointer ${pickDetail?.[0]?.prediction?.vote === "Yes" || pickDetail?.[0]?.prediction?.vote === "yes"
                ? "bg-green-500"
                : pickDetail?.[0]?.prediction?.vote === "No" || pickDetail?.[0]?.prediction?.vote === "no"
                  ? "bg-red-500"
                  : "bg-[#0080FE]"
              } text-white`
              : `cursor-not-allowed bg-transparent text-white`
              }`}
            onClick={
              timeLeft ? undefined : () => voteNowHandler(pickId, potInfo.id)
            }
          >
            <div className="flex gap-2 items-center">
              <p>
                {" "}
                {pickDetail?.[0]?.prediction?.vote?.toUpperCase()
                  ? pickDetail?.[0]?.prediction?.vote?.toUpperCase()
                  : "Vote Now"}
              </p>
              {!timeLeft && <img src={editIcon} className="h-5 w-5" />}
            </div>
          </button>

          <button
            className={`${baseButtonClass} cursor-pointer bg-transparent text-white`}
            onClick={() => {
              const path = window.location.pathname;
              const state =
                path === "/rounds"
                  ? {
                    page: path,
                    sub: cartType,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    status: potInfo.status,
                    round,
                    pickStatus: pickDetail?.[0]?.status,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  }
                  : {
                    page: path,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    status: potInfo.status,
                    round,
                    pickId,
                    pickStatus: pickDetail?.[0]?.status,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  };
              navigate("/V2-pickDetail", { state });
            }}
          >
            {label} Detail
          </button>
        </>
      ) : isWon ? <>
        <button
          className={`${baseButtonClass} cursor-not-allowed bg-[#FFFFFF1F] text-white flex 
              items-center justify-between gap-2 py-2`}
          disabled
        >
          {/* Faded content */}
          <div className="flex items-center gap-2 opacity-50">
            <img
              src={pickDetail[0].prediction.logo}
              className="w-[24px] h-[24px]"
              alt={pickDetail[0].prediction.short_name || label}
            />
            <p>
              {pickDetail[0].prediction.short_name?.slice(0, 3).toUpperCase()}
            </p>
          </div>

          {/* Full-opacity Lost badge */}
          <div className="flex items-center gap-1 bg-[#00C05B] px-2 py-1 rounded-full">
            <span className="h-2 w-2 bg-white rounded-full inline-block"></span>
            <span className="text-sm text-white font-medium">Won</span>
          </div>
        </button>

        <button
          className={`${baseButtonClass} cursor-pointer bg-transparent text-white`}
          onClick={() => {
            const path = window.location.pathname;
            const state =
              path === "/rounds"
                ? {
                  page: path,
                  sub: cartType,
                  potId: potInfo.id,
                  matchWeeksId: potInfo.current_match_week_id,
                  seasonId: potInfo.season,
                  logo: potInfo.season_logo,
                  soasonName: potInfo.season_name,
                  potValue: potInfo.pot_value,
                  currency: potInfo.pot_currency,
                  pickStatus: pickDetail?.[0]?.status,
                  status: potInfo.status,
                  round,
                  pickId,
                  currentMatchWeek: potInfo.current_match_week || 1,
                  matchWeeks: potInfo.current_match_week_id,
                  totalPick:
                    potInfo.active_picks_count + potInfo.lost_picks_count,
                  isTimeEnd: timeLeft,
                  btnColor: btn_color,
                  configuredLeagueId: potInfo.configured_league_id
                }
                : {
                  page: path,
                  potId: potInfo.id,
                  matchWeeksId: potInfo.current_match_week_id,
                  seasonId: potInfo.season,
                  logo: potInfo.season_logo,
                  soasonName: potInfo.season_name,
                  potValue: potInfo.pot_value,
                  currency: potInfo.pot_currency,
                  pickStatus: pickDetail?.[0]?.status,
                  status: potInfo.status,
                  round,
                  pickId,
                  currentMatchWeek: potInfo.current_match_week || 1,
                  matchWeeks: potInfo.current_match_week_id,
                  totalPick:
                    potInfo.active_picks_count + potInfo.lost_picks_count,
                  isTimeEnd: timeLeft,
                  btnColor: btn_color,
                  configuredLeagueId: potInfo.configured_league_id
                };
            navigate("/V2-pickDetail", { state });
          }}
        >
          {label} Detail
        </button>
      </> : isLost ? (
        <>
          <button
            className={`${baseButtonClass} cursor-not-allowed bg-[#FFFFFF1F] text-white flex 
              items-center justify-between gap-2 py-2`}
            disabled
          >
            {/* Faded content */}
            <div className="flex items-center gap-2 opacity-50">
              <img
                src={pickDetail[0].prediction.logo}
                className="w-[24px] h-[24px]"
                alt={pickDetail[0].prediction.short_name || label}
              />
              <p>
                {pickDetail[0].prediction.short_name?.slice(0, 3).toUpperCase()}
              </p>
            </div>

            {/* Full-opacity Lost badge */}
            <div className="flex items-center gap-1 bg-[#FF4956] px-2 py-1 rounded-full">
              <span className="h-2 w-2 bg-white rounded-full inline-block"></span>
              <span className="text-sm text-white font-medium">Lost</span>
            </div>
          </button>

          <button
            className={`${baseButtonClass} cursor-pointer bg-transparent text-white`}
            onClick={() => {
              const path = window.location.pathname;
              const state =
                path === "/rounds"
                  ? {
                    page: path,
                    sub: cartType,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  }
                  : {
                    page: path,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  };
              navigate("/V2-pickDetail", { state });
            }}
          >
            {label} Detail
          </button>
        </>
      ) : teamType === "NPY" && !isTeamSelected ? (
        <>
          <button
            className={`${baseButtonClass} ${!timeLeft
              ? "cursor-pointer bg-[#0080FE] text-white"
              : "cursor-not-allowed bg-transparent text-white"
              }`}
            onClick={timeLeft ? undefined : () => {
              const userInfo = localStorage.getItem("userInfo");
              const userId = userInfo ? JSON.parse(userInfo).userId : undefined;
              window.dataLayer.push({
                'userId': userId,
                'event': 'click',
                'clickText': `Choose Pick ${label.split(" ")[1]}`,
                'clickID': `btn-choose-pick${label.split(" ")[1]}`,
                'roundID': potInfo.id,
                'leagueID': potInfo.season_name,
              });
              handlePickClick("choose")
            }}
          >
            {isTeamSelected ? (
              <>
                <img
                  src={pickDetail[0].prediction.logo}
                  className="w-[24px] h-[24px]"
                  alt={pickDetail[0].prediction.short_name || label}
                />
                {pickDetail[0].prediction.short_name}
              </>
            ) : (
              <>Choose {label}</>
            )}
          </button>

          <button
            className={`${baseButtonClass} cursor-pointer bg-transparent text-white`}
            onClick={() => {
              dispatch(fetchFixtures([]));
              const path = window.location.pathname;
              const state =
                path === "/rounds"
                  ? {
                    page: path,
                    sub: cartType,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  }
                  : {
                    page: path,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  };
              navigate("/V2-pickDetail", { state });
            }}
          >
            {label} Detail
          </button>
        </>
      ) : isTeamSelected ? (
        <>
          <button
            // disabled={!timeLeft}
            className={`${baseButtonClass} flex items-center gap-2 ${!timeLeft
              ? "bg-[#FFFFFF1F] text-white"
              : "bg-transparent text-white"
              }`}
            onClick={timeLeft ? undefined : () => handlePickClick("edit")}
          >
            <img
              src={pickDetail[0].prediction.logo}
              className="w-[24px] h-[24px]"
              alt={pickDetail[0].prediction.short_name || label}
            />
            <p>{pickDetail[0].prediction.short_name} </p>
            {!timeLeft && <img src={editIcon} className="h-5 w-5" />}
          </button>

          <button
            className={`${baseButtonClass} cursor-pointer bg-transparent text-white`}
            onClick={() => {
              dispatch(fetchFixtures([]));
              const path = window.location.pathname;
              const state =
                path === "/rounds"
                  ? {
                    page: path,
                    sub: "myRound",
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  }
                  : {
                    page: path,
                    potId: potInfo.id,
                    matchWeeksId: potInfo.current_match_week_id,
                    seasonId: potInfo.season,
                    logo: potInfo.season_logo,
                    soasonName: potInfo.season_name,
                    potValue: potInfo.pot_value,
                    currency: potInfo.pot_currency,
                    pickStatus: pickDetail?.[0]?.status,
                    status: potInfo.status,
                    round,
                    pickId,
                    currentMatchWeek: potInfo.current_match_week || 1,
                    matchWeeks: potInfo.current_match_week_id,
                    totalPick:
                      potInfo.active_picks_count + potInfo.lost_picks_count,
                    isTimeEnd: timeLeft,
                    btnColor: btn_color,
                    configuredLeagueId: potInfo.configured_league_id
                  };
              navigate("/V2-pickDetail", { state });
            }}
          >
            {label} Detail
          </button>
        </>
      ) : lastEntryTimeLeft ? (
        <button
          className={`${baseButtonClass} ${potInfo?.entry_closed === false
            ? "cursor-pointer bg-[#00C05B] text-white"
            : "cursor-not-allowed bg-transparent text-white"
            }`}
          onClick={() => {

            if (potInfo.pot_value > potInfo.current_pot_value) {
              dispatch(updateRedeemPopup(true));
              dispatch(updatePickRemains(1));
              dispatch(updatePotTokenValue(potInfo.pot_token));
              dispatch(updateSelectedPot(potInfo.id));
            } else {
              showErrorToast('Entry closed for this round, please join other rounds.')
            }
          }}
        >
          Add a 2nd Pick
        </button>
      ) : (
        <button
          disabled={lastEntryTimeLeft}
          className={`${baseButtonClass} cursor-not-allowed bg-transparent text-white`}
        >
          Add a 2nd Pick
        </button>
      )}
    </div>
  );
};

const MyRoundSection = ({
  potInfo,
  viewFixtureHandler,
  round,
  timeLeft,
  leagueId,
  btn_color,
  lastEntryTimeLeft,
  cartType,
  gameName,
  gameId
}) => {
  const { showToast, showErrorToast } = useToastMessage();
  if (!potInfo?.pick_id?.length) return null;
  const pickDetail1 = potInfo.pick_id.filter(
    (ele) => ele.pick_number === "1/2" || ele.pick_number === "1/1"
  );

  const pickDetail2 = potInfo.pick_id.filter(
    (ele) => ele.pick_number === "2/2"
  );

  const teamType1 = pickDetail1[0]?.prediction?.team_type;
  const teamType2 = pickDetail2[0]?.prediction?.team_type;

  const isPickSecondPresen = potInfo?.max_number_of_picks == 1 ? false : true

  return (
    <div className="flex flex-col gap-4">
      <RenderPickRow
        pickDetail={pickDetail1}
        pickId={pickDetail1[0]?.pick_id}
        potInfo={potInfo}
        label="Pick 1"
        teamType={teamType1}
        viewFixtureHandler={viewFixtureHandler}
        round={round}
        timeLeft={timeLeft}
        leagueId={leagueId}
        btn_color={btn_color}
        lastEntryTimeLeft={lastEntryTimeLeft}
        showErrorToast={showErrorToast}
        cartType={cartType}
      />
      {
        isPickSecondPresen && <RenderPickRow
          pickId={pickDetail2[0]?.pick_id}
          pickDetail={pickDetail2}
          potInfo={potInfo}
          label="Pick 2"
          teamType={teamType2}
          viewFixtureHandler={viewFixtureHandler}
          round={round}
          timeLeft={timeLeft}
          leagueId={leagueId}
          btn_color={btn_color}
          lastEntryTimeLeft={lastEntryTimeLeft}
          showErrorToast={showErrorToast}
          cartType={cartType}
        />
      }

    </div>
  );
};

const CompletedRoundSection = ({
  potInfo,
  viewFixtureHandler,
  round,
  timeLeft,
  leagueId,
  btn_color,
  cartType
}) => {
  const navigate = useNavigate();

  if (!potInfo?.pick_id?.length && potInfo?.entry_closed === true) {
    return (
      <div className="flex flex-col gap-4">
        <button
          className="w-full opacity-50 cursor-not-allowed mt-4 border border-[#FFFFFF33] text-white font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition text-center"
          disabled
        >
          Entry Closed
        </button>
        <button
          className="w-full cursor-pointer font-bold border-2 border-white/50 text-[#ffffff] sm:text-lg py-2 sm:py-3 rounded-lg"
          onClick={() => {
            let path = window.location.pathname;
            navigate("/V2-pickDetail", {
              state: { page: path, sub: cartType },
            });
          }}
        >
          View Details
        </button>
      </div>
    );
  }

  if (!potInfo?.pick_id?.length && potInfo?.entry_closed === false) {
    return (
      <div className="flex flex-col gap-4">
        <button
          className="w-full opacity-50 cursor-not-allowed mt-4 text-white border-2 border-white/30  font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition text-center"
          disabled
        >
          Pick 1 Not Joined
        </button>
        <button
          className="w-full opacity-50 cursor-not-allowed text-white font-bold text-base border-2 border-white/30  sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition text-center"
          disabled
        >
          Pick 2 Not Joined
        </button>
      </div>
    );
  }

  const pickDetail1 = potInfo.pick_id.filter(
    (ele) => ele.pick_number === "1/2" || ele.pick_number === "1/1"
  );

  const pickDetail2 = potInfo.pick_id.filter(
    (ele) => ele.pick_number === "2/2"
  );

  const teamType1 = pickDetail1[0]?.prediction?.team_type;
  const teamType2 = pickDetail2[0]?.prediction?.team_type;

  const isPickSecondPresen = potInfo?.max_number_of_picks == 1 ? false : true

  if (potInfo.pick_id.length === 1) {
    return (
      <div className="flex flex-col gap-4 mt-7">
        <RenderPickRow
          pickDetail={pickDetail1}
          pickId={pickDetail1[0]?.pick_id}
          potInfo={potInfo}
          label="Pick 1"
          teamType={teamType1}
          viewFixtureHandler={viewFixtureHandler}
          round={round}
          timeLeft={timeLeft}
          leagueId={leagueId}
          cartType={cartType}
        />
        {
          isPickSecondPresen ? <button
            className="w-full opacity-50 cursor-not-allowed bg-gray-400 text-white font-bold text-base sm:text-lg py-2 sm:py-3 rounded-lg shadow-lg transition text-center"
            disabled
          >
            Pick 2 Not Joined
          </button> : <div className="py-6"></div>
        }

      </div>
    );
  }



  return (
    <div className="flex flex-col gap-4 mt-7">
      <RenderPickRow
        pickDetail={pickDetail1}
        pickId={pickDetail1[0]?.pick_id}
        potInfo={potInfo}
        label="Pick 1"
        teamType={teamType1}
        viewFixtureHandler={viewFixtureHandler}
        round={round}
        timeLeft={timeLeft}
        leagueId={leagueId}
        btn_color={btn_color}
      />
      {
        isPickSecondPresen && <RenderPickRow
          pickId={pickDetail2[0]?.pick_id}
          pickDetail={pickDetail2}
          potInfo={potInfo}
          label="Pick 2"
          teamType={teamType2}
          viewFixtureHandler={viewFixtureHandler}
          round={round}
          timeLeft={timeLeft}
          leagueId={leagueId}
          btn_color={btn_color}
        />
      }

    </div>
  );
};

const RoundCard = ({
  potInfo,
  netPotValue,
  pot_token,
  leagueId,
  cartType,
  viewFixtureHandler,
  logo,
  league,
  amount,
  currency,
  round,
  filled,
  up,
  down,
  colorFrom,
  colorTo,
  isMyRound = false,
  key,
  status,
  endTime,
  lastEntryTime,
  active_picks_count,
  lost_picks_count,
  color = "rgb(61, 24, 93)",
  pot_value_percentage,
  round_amount,
  picks = [],
  btn_color,
  btn_text_color,
  progress_color = "rgb(0, 128, 254)",
  pot_value = 0,
  r_progress_color,
  gameName,
  gameId,
  
}) => {
  let [timeEnd, setIsTimeEnd] = useState(false);
  const { showToast, showErrorToast } = useToastMessage();

  const dispatch = useDispatch();

  const calculateTimeLeft = () => {
    // if (endTime) {
    const difference = +new Date(endTime) - +new Date();

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return timeLeft;
  };



  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [endTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      const isAllZero = Object.values(newTimeLeft).every((val) => val === 0);
      if (isAllZero) {
        setIsTimeEnd(true);
        clearInterval(timer); // Optional: stop ticking once ended
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  const calculateLastTimeLeft = () => {
    const difference = +new Date(lastEntryTime) - +new Date();
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [lastEntryTimeLeft, setLastEntryTimeLeft] = useState(
    calculateLastTimeLeft()
  );
  const [isTimeLeft, setIsTimeLeft] = useState(() => {
    return +new Date(lastEntryTime) - +new Date() > 0;
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const difference = +new Date(lastEntryTime) - +new Date();
      const newTimeLeft = calculateLastTimeLeft();
      setLastEntryTimeLeft(newTimeLeft);

      const hasTimeLeft = difference > 0;
      setIsTimeLeft(hasTimeLeft);

      if (!hasTimeLeft) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [lastEntryTime]);

  const roundToJoinPot = async (round) => {
    try {
      const token = localStorage.getItem("access_token");
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const res = await axios.post(
        `${baseURL}/pot/joinpot`,
        {
          number_of_picks: 1,
          pot: round,
          player: userInfo.userId,
        },
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );

      if (res.data) {
        showToast("Successfully joined the pot!");
        dispatch(fetchRoundPageCategory("myRound"));
        console.log("Join pot response:", res.data);
      } else {
        showErrorToast("No data returned from the server.");
      }
    } catch (e) {
      const errorMessage = e?.response?.data?.message;
      showErrorToast(errorMessage);
    }
  };

  const matchWeeks =
    useSelector((state) => state.roundToJoin.roundToJoinPotData)
      ?.find((ele) => ele.league_id == leagueId)
      ?.pots.find((item) => item.id === round)
      ?.pot_matchweek?.split("-")[1] || "1";

  const pot = useSelector((state) => state.roundToJoin.roundToJoinPotData)
    ?.find((ele) => ele.league_id == leagueId)
    ?.pots.find((item) => item.id === round);


  let isTimeEndOnRoundStart = (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) ||
    (lastEntryTimeLeft.days === 0 && lastEntryTimeLeft.hours === 0 && lastEntryTimeLeft.minutes === 0 && lastEntryTimeLeft.seconds === 0)

  if (!isMyRound) {
    return (
      <>
        <div
          key={key}
          className={`w-full min-w-[290px] sm:min-w-[350px] max-w-[350px] p-4 sm:p-6 rounded-2xl shadow-lg relative mb-4 sm:mb-0 flex flex-col justify-between`}
          style={{ backgroundColor: color }}
        >
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                // color: "#1BA56F",
                fontWeight: "700",
                borderRadius: "0px !important",
                border: `1px solid #1BA56F`,
              },
            }}
          />
          <div className="flex items-center mb-4 gap-4">
            <div
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "white",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={logo}
                alt="League Logo"
                style={{
                  width: "80%",
                  height: "80%",
                  objectFit: "contain",
                }}
                
              />
            </div>
            <div className="flex-1">
              <div className="font-archivo text-lg font-semibold text-white leading-tight">
                {league}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between mb-2">
            <span
              className="font-bold font-archivo text-lg px-4 py-1 rounded-[20px] bg-[#00C05B] text-white shadow mr-3"
              style={{
                fontWeight: 700,
                display: "inline-block",
                background: "linear-gradient(90deg, #007FFF 0%, #00C05B 100%)",
              }}
            >
              <div className="flex gap-1 items-center">
                <span className="text-[14px] font-[500]">UP TO</span>
                <span className="flex items-center justify-center text-2xl font-bold">
                  $
                </span>
                <p>{isTimeEndOnRoundStart ? amountFormat(Number(netPotValue)) : amountFormat(Number(amount))}</p>
              </div>
            </span>
            <span className="text-gray-100 text-[15px] font-semibold">
              RND : {round}
            </span>
          </div>
          {/* Filled Amount and Active in one row */}
          <div className="flex items-center mb-2 mt-6">
            <div className="text-[#E7E7E7] text-[14px] flex-1">
              Round filled for $ {amountFormat(Number(netPotValue) || 0)}
            </div>
            <span
              className="text-white text-xs px-3 py-1 rounded-full flex items-center gap-1 font-semibold"
              style={{
                backgroundColor: potInfo?.configured_league_id === "140" ? "#FFFFFF" : "#00C05B",
                color: potInfo?.configured_league_id === "140" ? "#00C05B" : "#FFFFFF"
              }}
            >
              <span
                className="h-2 w-2 rounded-full mr-1"
                style={{
                  display: "inline-block",
                  backgroundColor: potInfo?.configured_league_id === "140" ? "#00C05B" : "#FFFFFF"
                }}
              ></span>

              {status === 'Waitlist' ? 'Open' : status}
            </span>
          </div>
          {/* Progress Bar */}

          <div className="w-full h-[6px] bg-white/20 rounded-full mb-4">
            <div
              className="h-full rounded-full"
              style={{
                width: isTimeEndOnRoundStart
                  ? "100%"
                  : `${Math.min(100, Math.max(0, pot_value_percentage || 0))}%`,
                backgroundColor: progress_color,
              }}
            ></div>

          </div>
          {/* Timer and Up/Down */}
          <div className="flex justify-between items-center">
            <div className="flex flex-col text-white">
              <div className="flex items-center text-[18px] sm:text-[16px] font-bold leading-none">
                <span className="w-[28px] sm:w-[24px] text-center">
                  {String(timeLeft.days).padStart(2, "0")}
                </span>
                <span className="mx-1">:</span>
                <span className="w-[28px] sm:w-[24px] text-center">
                  {String(timeLeft.hours).padStart(2, "0")}
                </span>
                <span className="mx-1">:</span>
                <span className="w-[28px] sm:w-[24px] text-center">
                  {String(timeLeft.minutes).padStart(2, "0")}
                </span>
                <span className="mx-1">:</span>
                <span className="w-[28px] sm:w-[24px] text-center">
                  {String(timeLeft.seconds).padStart(2, "0")}
                </span>
              </div>
              <div className="flex items-center text-[#fff] text-xs mt-1">
                <span className="w-[28px] sm:w-[28px] text-center">Days</span>
                <span className="mx-1"></span>
                <span className="w-[28px] sm:w-[28px] text-center">Hrs</span>
                <span className="mx-1"></span>
                <span className="w-[28px] sm:w-[28px] text-center">Min</span>
                <span className="mx-1"></span>
                <span className="w-[28px] sm:w-[28px] text-center">Secs</span>
              </div>
            </div>
            <div className="flex items-center text-[16px] font-semibold gap-4 ml-auto">
              <span className="text-green-400 flex items-center">
                ▲ <span className="text-white ml-1">{up}</span>
              </span>
              <span className="text-red-400 flex items-center">
                ▼ <span className="text-white ml-1">{down || 0}</span>
              </span>
            </div>
          </div>
          {/* Play Now Button */}
          <RoundToJoinSection
            potInfo={potInfo}
            league={league}
            leagueId={leagueId}
            timeLeft={timeEnd}
            viewFixtureHandler={viewFixtureHandler}
            round={round}
            pot_token={pot_token}
            btn_color={btn_color}
            btn_text_color={btn_text_color}
            gameName={gameName}
            gameId={gameId}
            
          />
        </div>
      </>
    );
  }


  const baseButtonClass =
    "flex-1 min-h-[48px] text-[14px] flex justify-center items-center font-bold px-2 py-2 sm:py-3 border-2 border-white/20 rounded-lg shadow-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-white/50";

  return (

    <div
      className={`w-[350px] min-w-[350px] max-w-[350px] p-4 sm:p-6 rounded-2xl shadow-lg relative mb-4 sm:mb-0 flex flex-col justify-between`}
      style={{ backgroundColor: color }}
    >
      <div className="pl-0 flex flex-col gap-2 sm:gap-3">
        <div className="flex items-center mb-1 sm:mb-4 gap-4">
          <div
            style={{
              width: "60px",
              height: "60px",
              backgroundColor: "white",
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logo}
              alt="League Logo"
              style={{
                width: "80%",
                height: "80%",
                objectFit: "contain",
              }}
            />
          </div>
          {/* <img src={logo} alt="League Logo" className="w-[60px] h-[60px] bg-white rounded-full mb-2 object-contain" /> */}
          <div className="font-archivo text-base sm:text-lg font-semibold text-white">
            {league}
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span
              className="font-bold font-archivo text-md px-4 py-1 rounded-[20px] text-[16px] sm:text-[18px] shadow"
              style={{
                background: "linear-gradient(90deg, #007FFF 0%, #00C05B 100%)",
                color: "#fff",
                fontWeight: 700,
                display: "inline-block",
              }}
            >
              <div className="flex gap-1 items-center">
                <span className="text-[14px] font-[500]">UP TO</span>
                <span className="flex items-center justify-center text-2xl font-bold">
                  $
                </span>
                <p>{isTimeEndOnRoundStart ? amountFormat(Number(netPotValue)) : amountFormat(Number(amount))}</p>
              </div>
            </span>

          </div>

          <div className="text-gray-100 text-[14px] sm:text-[16px] font-semibold">
            RND : {round}
          </div>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-[#E7E7E7] text-[12px] sm:text-[14px]">
            Round filled for $ {amountFormat(Number(netPotValue) || 0)}
          </span>
          <span
            className="text-white text-xs px-3 py-1 rounded-full flex items-center gap-1 font-semibold"
            style={{
              backgroundColor: potInfo?.configured_league_id === "140" ? "#FFFFFF" : "#00C05B",
              color: potInfo?.configured_league_id === "140" ? "#00C05B" : "#FFFFFF"
            }}
          >
            {/* <span
              className="h-2 w-2 bg-white rounded-full mr-1"
              style={{
                display: "inline-block",
                backgroundColor:
                  btn_color === "#FFFFFF" ||
                    btn_color?.toLowerCase() === "white"
                    ? "#00C05B"
                    : "white",
              }}
            ></span> */}
            <span
              className="h-2 w-2 rounded-full mr-1"
              style={{
                display: "inline-block",
                backgroundColor: potInfo?.configured_league_id === "140" ? "#00C05B" : "#FFFFFF"
              }}
            ></span>

            {status === 'Waitlist' ? 'Open' : status === 'JackPot' ? 'Jackpot' : status}
          </span>
        </div>
        <div className="w-full h-[6px] bg-white/20 rounded-full">
          <div
            className="h-full rounded-full"
            // style={{
            //   width: `${Math.min(
            //     100,
            //     Math.max(0, pot_value_percentage || 0)
            //   )}%`,
            //   backgroundColor: progress_color,
            // }}
            style={{
              width: isTimeEndOnRoundStart
                ? "100%"
                : `${Math.min(100, Math.max(0, pot_value_percentage || 0))}%`,
              backgroundColor: progress_color,
            }}
          ></div>
        </div>
        <div className="flex justify-between items-center">
          <div className="flex flex-col text-white">
            <div className="flex items-center text-[18px] sm:text-[16px] font-bold leading-none">
              <span className="w-[28px] sm:w-[24px] text-center">
                {String(timeLeft.days).padStart(2, "0")}
              </span>
              <span className="mx-1">:</span>
              <span className="w-[28px] sm:w-[24px] text-center">
                {String(timeLeft.hours).padStart(2, "0")}
              </span>
              <span className="mx-1">:</span>
              <span className="w-[28px] sm:w-[24px] text-center">
                {String(timeLeft.minutes).padStart(2, "0")}
              </span>
              <span className="mx-1">:</span>
              <span className="w-[28px] sm:w-[24px] text-center">
                {String(timeLeft.seconds).padStart(2, "0")}
              </span>
            </div>
            <div className="flex items-center text-[#A0A0A0] text-xs mt-1">
              <span className="w-[28px] sm:w-[28px] text-center">Days</span>
              <span className="mx-1"></span>
              <span className="w-[28px] sm:w-[28px] text-center">Hrs</span>
              <span className="mx-1"></span>
              <span className="w-[28px] sm:w-[28px] text-center">Min</span>
              <span className="mx-1"></span>
              <span className="w-[28px] sm:w-[28px] text-center">Secs</span>
            </div>
          </div>
          <div className="flex items-center text-[16px] sm:text-[16px] font-semibold gap-3 ml-auto">
            <span className="text-green-400 flex items-center">
              ▲ <span className="text-white ml-1">{up}</span>
            </span>
            <span className="text-red-400 flex items-center">
              {/* {down ? ( */}
              <>
                ▼ <span className="text-white ml-1">{down || 0}</span>
              </>
              {/* ) : null} */}
            </span>
          </div>
        </div>

        {/* Pick 2 - Show only if exists */}
        {cartType === "roundToPlay" ? (
          <RoundToJoinSection
            league={league}
            potInfo={potInfo}
            leagueId={leagueId}
            timeLeft={timeEnd}
            viewFixtureHandler={viewFixtureHandler}
            round={round}
            pot_token={pot_token}
            btn_color={btn_color}
            btn_text_color={btn_text_color}
            cartType="roundToPlay"
            gameName={gameName}
            gameId={gameId}
            
          />
        ) : cartType === "myRound" ? (
          <MyRoundSection
            potInfo={potInfo}
            league={league}
            leagueId={leagueId}
            timeLeft={timeEnd}
            viewFixtureHandler={viewFixtureHandler}
            round={round}
            pot_token={pot_token}
            btn_color={btn_color}
            lastEntryTimeLeft={isTimeLeft}
            btn_text_color={btn_text_color}
            cartType="myRound"
            gameName={gameName}
            gameId={gameId}
          />
        ) : cartType === "completed" ? (
          <CompletedRoundSection
            potInfo={potInfo}
            league={league}
            leagueId={leagueId}
            timeLeft={timeEnd}
            viewFixtureHandler={viewFixtureHandler}
            round={round}
            btn_color={btn_color}
            btn_text_color={btn_text_color}
            cartType="compleated"
          />
        ) : (
          <>
            <MyRoundSection
              potInfo={potInfo}
              league={league}
              leagueId={leagueId}
              timeLeft={timeEnd}
              viewFixtureHandler={viewFixtureHandler}
              round={round}
              pot_token={pot_token}
              btn_color={btn_color}
              lastEntryTimeLeft={isTimeLeft}
              btn_text_color={btn_text_color}
              cartType={cartType}
              gameName={gameName}
              gameId={gameId}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default RoundCard;